import { getExperimentFlags, useGeneratePath, useStaticUrls } from 'platform-components';
import { getFeatureFlags } from 'platform-components/src/components/app-factory/selectors';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { getIsInformaticsTeacher, getSelectedSubjectOrDefault } from 'store/courses/selectors';
import { useNewLabPathAccess } from 'common.components/TeacherHeader/lib/useNewLabPathAccess';
import { RedirectToNewLab } from 'common.components/TeacherHeader/lib/RedirectToNewLab';

export const ProfilePage = () => {
    const experimentsFlags = useSelector(getExperimentFlags);
    const featureFlags = useSelector(getFeatureFlags);
    const { teamId, subject: subjectFromParams } = useParams<{ teamId: string; subject: string }>();
    const isInformaticsTeacher = useSelector(getIsInformaticsTeacher);

    const staticUrls = useStaticUrls();

    const subject = useSelector((store) =>
        getSelectedSubjectOrDefault(store, { classId: teamId, subject: subjectFromParams })
    );
    const generatePath = useGeneratePath();
    const generateNewLabPath = (path: string) => generatePath(path, { teamId, subject });

    const { newLabPath } = useNewLabPathAccess({
        featureFlags,
        experimentsFlags,
        teamId,
        subject,
        isInformaticsTeacher,
        staticUrls,
    });

    if ((experimentsFlags as Partial<Record<string, number>>)?.enableNewProfile === 1) {
        RedirectToNewLab(generateNewLabPath(newLabPath.profile));
        return null;
    }

    RedirectToNewLab(
        `${staticUrls.notFound}?${new URLSearchParams([
            ['return_to', generateNewLabPath(newLabPath.profile)],
        ]).toString()}`
    );
    return null;
};
